import { Component, Input, OnInit } from '@angular/core';
import {
  KPIS,
  HealthCheck,
  SurveyListing,
} from '../../../shared/services/buyer-api/survey.interface';

@Component({
  selector: 'ps-health-check-widget',
  templateUrl: './health-check-widget.component.html',
  styleUrls: ['./health-check-widget.component.css'],
})
export class HealthCheckWidgetComponent implements OnInit {
  @Input() survey: SurveyListing = {} as SurveyListing;
  public surveyId!: number;
  public healthCheck: HealthCheck = {} as HealthCheck;

  public ngOnInit(): void {
    this.surveyId = this.survey.surveyId;
    this.healthCheck = this._mapSurveyHealth(this.survey.healthCheck);
  }

  private _mapSurveyHealth(kpis: KPIS[] = []): HealthCheck {
    if (!kpis.length) {
      return {
        kpis: [],
        count: {},
      };
    }

    return {
      count: kpis.reduce((acc, { status_text }) => {
        acc[status_text] = (acc[status_text] || 0) + 1;
        return acc;
      }, {} as { [Key: string]: number }),
      kpis: kpis,
    };
  }

  public getHealthKpiClass(status: string): string {
    switch (status) {
      case 'RED':
        return 'red_pill_drop';
      case 'GREEN':
        return 'green_pill_drop';
      case 'YELLOW':
        return 'yellow_pill_drop';
      default:
        return 'grey_pill_drop';
    }
  }
}
